import { createConstants } from 'redux-model-tools';

export default createConstants('OPENINGS_DIRECTORY_DSP', [
  'LOAD_OPENINGS',
  'LOAD_OPENINGS_RESULT',
]);
